import * as React from 'react';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useApplicationContext } from '../../utils/applicationContext';
import { SliderModalLoadable, type TSliderModalProps } from '../CompareBannerContainer/loadable';
import {
  trackCloseCompareModal,
  trackScrollCompareModal,
  trackShowCompareModal,
} from '../CompareBannerContainer/tracking';
import { COMPARE_FLIGHT_SLIDES_CONFIG } from '../OffersContainer/constants/compare';

type TSlides = TSliderModalProps['slides'];

export interface ICompareFlightModalContainerProps {
  onClose(): void;
}

/**
 * Модалка-сторис «Сравнение ЖК» с аналитикой. Открывается из баннера и из тултипа у кнопки сравнения.
 */
export const CompareFlightModalContainer = ({ onClose }: ICompareFlightModalContainerProps) => {
  const { config } = useApplicationContext();

  const slides = config.get<TSlides>(COMPARE_FLIGHT_SLIDES_CONFIG) ?? [];

  const handleClose = React.useCallback(() => {
    trackCloseCompareModal();
    onClose();
  }, [onClose]);

  const handleSlideChange = React.useCallback((pageId: number) => {
    trackScrollCompareModal({ pageId });
  }, []);

  return (
    <ActionAfterViewObserver callback={() => trackShowCompareModal()} triggerOnce>
      <SliderModalLoadable slides={slides} onClose={handleClose} onSlideChange={handleSlideChange} />
    </ActionAfterViewObserver>
  );
};
